import { compose } from "redux";
import { Route } from "react-router-dom";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core";

import Tabs from "app/components/Tabs";
import routePaths from "app/routePaths";
import { APP_ROLES } from "app/app.constants";
import AccessControl from "app/components/AccessControl";
import ViewTab from "features/planner/components/View/ViewTab";

class ViewTabs extends PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <Tabs
        classes={{
          root: classes.tabsRoot,
        }}
      >
        <AccessControl accessLevel={[APP_ROLES.ADMIN, APP_ROLES.PLANNER]}>
          <Route
            path={[routePaths.view, routePaths.root]}
            children={({ match }) => (
              <ViewTab
                to={routePaths.root}
                isActive={() => match.isExact}
                activeClassName={classes.rootTabSelected}
              >
                Planner
              </ViewTab>
            )}
          />
        </AccessControl>
        <AccessControl
          accessLevel={[APP_ROLES.ADMIN, APP_ROLES.VIEWER, APP_ROLES.PLANNER]}
        >
          <ViewTab to="/reports" activeClassName={classes.reportTabSelected}>
            Reports
          </ViewTab>
        </AccessControl>
      </Tabs>
    );
  }
}

const styles = theme => ({
  tabsRoot: {
    backgroundColor: "transparent",
  },
  rootTabSelected: {
    backgroundColor: theme.altus.background.view,
    color: theme.palette.getContrastText(theme.altus.background.view),
    pointerEvents: "none",
  },
  reportTabSelected: {
    pointerEvents: "none",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.getContrastText(theme.palette.background.default),
  },
});

export default compose(withStyles(styles))(ViewTabs);
